import { useMemo } from 'react';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Cell } from 'recharts';
import { UserData } from '../../types';
import { computeEngagementBuckets } from '../../lib/metrics';

const COLORS = ['#e5e7eb', '#93c5fd', '#60a5fa', '#3b82f6', '#1d4ed8'];

interface EngagementChartProps {
  users: UserData[];
}

export function EngagementChart({ users }: EngagementChartProps) {
  const data = useMemo(() => computeEngagementBuckets(users), [users]);

  return (
    <div className="chart-card">
      <h3>Engagement Distribution</h3>
      <p className="chart-subtitle">Users by total message count</p>
      <ResponsiveContainer width="100%" height={250}>
        <BarChart data={data}>
          <CartesianGrid strokeDasharray="3 3" stroke="#f0f0f0" />
          <XAxis dataKey="bucket" fontSize={11} tick={{ fill: '#6b7280' }} label={{ value: 'Messages', position: 'insideBottom', offset: -2, fontSize: 11, fill: '#9ca3af' }} />
          <YAxis fontSize={11} tick={{ fill: '#6b7280' }} allowDecimals={false} label={{ value: 'Users', angle: -90, position: 'insideLeft', fontSize: 11, fill: '#9ca3af' }} />
          <Tooltip />
          <Bar dataKey="count" name="Users" radius={[4, 4, 0, 0]}>
            {data.map((_, i) => (
              <Cell key={i} fill={COLORS[i % COLORS.length]} />
            ))}
          </Bar>
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
}
